import { useQueryClient } from '@tanstack/react-query'
import { LectureVideoDeleteRequest } from '../../../types/video'
import { useApiPostMutation } from '../useApi'

export const useVideosDeleteSpecific = () => {
  const queryClient = useQueryClient()
  const mutation = useApiPostMutation<LectureVideoDeleteRequest>()

  const deleteVideo = async (requestData: LectureVideoDeleteRequest) => {
    const result = await mutation.mutateAsync({
      url: '/lectures/videos/delete',
      data: requestData,
    })

    queryClient.invalidateQueries({ queryKey: ['videosDetail'] })
    queryClient.invalidateQueries({
      queryKey: ['lecture-list'],
    })
    queryClient.invalidateQueries({
      queryKey: ['lecturesStatus'],
    })

    return result
  }

  return {
    ...mutation,
    deleteVideo,
  }
}
